export const UserRole = {
  CHIEF_DIGITAL_CARE_NURSE: 'CHIEF_DIGITAL_CARE_NURSE',
  CHIEF_DIGITAL_CARE_PHYSICIAN: 'CHIEF_DIGITAL_CARE_PHYSICIAN',
  PRODUCT_TECH: 'PRODUCT_TECH',
  PRODUCT_TECH_HEALTH: 'PRODUCT_TECH_HEALTH',
  DE_IDENTIFIED_HI_VIEWER: 'DE_IDENTIFIED_HI_VIEWER',
  DIGITAL_CARE_NURSE: 'DIGITAL_CARE_NURSE',
  DIGITAL_SCREENING_NURSE: 'DIGITAL_SCREENING_NURSE',
  HEALTHCARE_TEAM_NURSE: 'HEALTHCARE_TEAM_NURSE',
  TECHNIQUE_NURSE: 'TECHNIQUE_NURSE',
  CHIEF_PHYSICIAN: 'CHIEF_PHYSICIAN',
  NUTRITIONIST: 'NUTRITIONIST',
  CLAIMS_EXAMINER: 'CLAIMS_EXAMINER',
  DIGITAL_CARE_PHYSICIAN: 'DIGITAL_CARE_PHYSICIAN',
  PHYSIOTHERAPIST: 'PHYSIOTHERAPIST',
  PHYSICAL_EDUCATOR: 'PHYSICAL_EDUCATOR',
  CARE_COORD_NURSE: 'CARE_COORD_NURSE',
  CARE_COORD_OPS: 'CARE_COORD_OPS',
  COMMUNITY: 'COMMUNITY',
  NAVIGATOR: 'NAVIGATOR',
  CHIEF_NAVIGATOR: 'CHIEF_NAVIGATOR',
  CHIEF_NAVIGATOR_OPS: 'CHIEF_NAVIGATOR_OPS',
  HEALTH_DECLARATION_NURSE: 'HEALTH_DECLARATION_NURSE',
  CHANNEL_ADMIN: 'CHANNEL_ADMIN',
  PSYCHOLOGIST: 'PSYCHOLOGIST',
  ON_SITE_PHYSICIAN: 'ON_SITE_PHYSICIAN',
  ON_SITE_NURSE: 'ON_SITE_NURSE',
  MANAGER_PHYSICIAN: 'MANAGER_PHYSICIAN',
  MANAGER_NUTRITIONIST: 'MANAGER_NUTRITIONIST',
  OBSTETRICIAN: 'OBSTETRICIAN',
  MANAGER_PSYCHOLOGIST: 'MANAGER_PSYCHOLOGIST',
  MANAGER_PHYSICAL_EDUCATOR: 'MANAGER_PHYSICAL_EDUCATOR',
  MED_RISK: 'MED_RISK',
  HEALTH_OPS_LEAD: 'HEALTH_OPS_LEAD',
  HEALTHCARE_TEAM_NURSE_REFERENCE: 'HEALTHCARE_TEAM_NURSE_REFERENCE',
  SCREENING_NURSE: 'SCREENING_NURSE',
  VIRTUAL_CLINIC_PHYSICIAN: 'VIRTUAL_CLINIC_PHYSICIAN',
  VIRTUAL_CLINIC_PEDIATRIC_PHYSICIAN: 'VIRTUAL_CLINIC_PEDIATRIC_PHYSICIAN',
  RISK_NURSE: 'RISK_NURSE',
  MED_EX: 'MED_EX',
  HEALTHCARE_TEAM_PHYSICIAN_MANAGEMENT: 'HEALTHCARE_TEAM_PHYSICIAN_MANAGEMENT',
  QUALITY_NURSE: 'QUALITY_NURSE'
}
